import { getExperiences } from '../components/experiences/utils';
import { getExperiencesByContext } from '../components/experiences/server';
import getConfig from '../config/runtime';

export const mergeFeatureFlagValues = (flags, query = {}) => {
  if (flags) {
    Object.keys(flags).map((flag) => {
      if (typeof query[flag] !== 'undefined') {
        flags[flag] = query[flag];
      }
    });
  }
  return flags;
};

export const fetchFeatureFlags = (context) => {
  const { publicRuntimeConfig } = getConfig();
  const { featureFlagName } = publicRuntimeConfig;
  let pageType;
  let returnedFlags = {};
  if (context.req && context.req.headers) {
    pageType = context.req?.headers['x-page-type'] || 'home';

    const experiencesByContext = getExperiencesByContext(context, pageType);

    const featureFlags = getExperiences(
      experiencesByContext?.experiences,
      featureFlagName
    );

    returnedFlags = mergeFeatureFlagValues(
      featureFlags[0]?.parameters || {},
      context.query
    );
  }
  return returnedFlags;
};
